import React from "react";
import ServicesSection from "../components/services/ServicesSection";

const Services = () => {
  return (
    <section className="relative w-full min-h-screen text-white">
       <ServicesSection />
    </section>
  );
};

export default Services;
